import type { ColumnType } from 'antd/es/table';
import type { Dispatch } from 'react';

import { sortByTime } from 'utils/antd/sorters';
import { formatDate } from 'utils/dayjs';

import type { StatementItem } from 'api';

import type { FindAccountByAccountNumber } from 'hooks/context/useVirtualAccounts';

import { ColumnTitle } from '@atoms/ColumnTitle';
import { DownloadThinIcon } from '@atoms/Icon/DownloadThinIcon';

import { FormattedDateTime } from '@molecules/FormattedDateTime';

export const getColumns = (
  findAccountByAccountNumber: FindAccountByAccountNumber,
  downloadReport: Dispatch<number>
): ColumnType<StatementItem>[] => {
  return [
    {
      key: 'empty_space',
      width: 50
    },
    {
      title: <ColumnTitle title="From" />,
      dataIndex: 'from',
      key: 'from',
      render: (from: string) => (
        <div className="text-lg">{formatDate(from)}</div>
      )
    },
    {
      title: <ColumnTitle title="To" />,
      dataIndex: 'to',
      key: 'to',
      render: (to: string) => <div className="text-lg">{formatDate(to)}</div>
    },
    {
      title: <ColumnTitle title="Create date (UTC)" />,
      dataIndex: 'created_at',
      key: 'created_at',
      render: (createdAt: string) => <FormattedDateTime value={createdAt} />,
      sorter: (a, b) => sortByTime(a.created_at, b.created_at),
      onHeaderCell: () => ({
        className: 'align-sorter-icon'
      })
    },
    {
      title: <ColumnTitle title="Account" />,
      dataIndex: 'virtual_account_number',
      key: 'virtual_account_number',
      align: 'right',
      render: (virtualAccountNumber: string) => {
        const account = findAccountByAccountNumber(virtualAccountNumber);

        return (
          <div>
            <p className="text-sm">{virtualAccountNumber}</p>
            <div className="font-semibold">{account?.name}</div>
          </div>
        );
      }
    },
    {
      title: <ColumnTitle title="Type" />,
      dataIndex: 'kind',
      key: 'kind',
      align: 'right',
      render: (kind: string) => {
        return <div className="capitalize">{kind}</div>;
      }
    },
    {
      title: <ColumnTitle title="Action" />,
      dataIndex: 'csv_file_id',
      key: 'uuid',
      align: 'center',
      render: (uuid: number) => {
        return (
          <div className="align-center flex h-full justify-center">
            <DownloadThinIcon
              className="cursor-pointer"
              fontSize="32px"
              onClick={() => downloadReport(uuid)}
            />
          </div>
        );
      }
    }
  ];
};
